// Automations: routines, versions, enrollments, dry runs (PRD §13).
// Import helpers from './route-def.js' (route, Ws, W, IdParam, items) and schemas from a sibling api-routines.ts.
import { OkSchema } from './api.js';
import * as R from './api-routines.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

const T = 'automations';

export const routineRoutes = {
  listRoutineTemplates: route({
    method: 'GET', path: '/workspaces/:workspaceId/routine-templates', summary: 'Plantillas de rutinas', tag: T,
    minRole: 'manager', params: Ws, response: items(R.RoutineTemplateSchema),
  }),
  listRoutines: route({
    method: 'GET', path: '/workspaces/:workspaceId/routines', summary: 'Rutinas de automatización', tag: T,
    minRole: 'manager', params: Ws, response: R.RoutineListSchema,
  }),
  createRoutine: route({
    method: 'POST', path: '/workspaces/:workspaceId/routines', summary: 'Crear rutina en borrador (en blanco o desde plantilla)', tag: T,
    minRole: 'manager', params: Ws, body: R.CreateRoutineSchema, response: R.RoutineDetailSchema, status: 201,
  }),
  pauseAllRoutines: route({
    method: 'POST', path: '/workspaces/:workspaceId/routines/pause-all', summary: 'Pausar todas las automatizaciones (detiene el trabajo no enviado)', tag: T,
    minRole: 'manager', params: Ws, response: R.PauseAllResultSchema,
  }),
  getRoutine: route({
    method: 'GET', path: '/workspaces/:workspaceId/routines/:routineId', summary: 'Rutina (versión vigente, prerrequisitos)', tag: T,
    minRole: 'manager', params: W({ routineId: IdParam }), response: R.RoutineDetailSchema,
  }),
  updateRoutine: route({
    method: 'PATCH', path: '/workspaces/:workspaceId/routines/:routineId', summary: 'Editar rutina (fuera de borrador crea una nueva versión)', tag: T,
    minRole: 'manager', params: W({ routineId: IdParam }), body: R.UpdateRoutineSchema, response: R.RoutineDetailSchema,
  }),
  changeRoutineState: route({
    method: 'POST', path: '/workspaces/:workspaceId/routines/:routineId/state', summary: 'Cambiar estado (borrador, prueba, activa, pausada)', tag: T,
    minRole: 'manager', params: W({ routineId: IdParam }), body: R.ChangeRoutineStateSchema, response: R.RoutineDetailSchema,
  }),
  dryRunRoutine: route({
    method: 'POST', path: '/workspaces/:workspaceId/routines/:routineId/dry-run', summary: 'Prueba en seco (sin efectos)', tag: T,
    minRole: 'manager', params: W({ routineId: IdParam }), body: R.DryRunRequestSchema, response: R.DryRunResultSchema,
  }),
  listRoutineEnrollments: route({
    method: 'GET', path: '/workspaces/:workspaceId/routines/:routineId/enrollments', summary: 'Inscripciones de la rutina', tag: T,
    minRole: 'manager', params: W({ routineId: IdParam }), query: R.EnrollmentListQuerySchema,
    response: R.EnrollmentListPageSchema,
  }),
  enrollInRoutine: route({
    method: 'POST', path: '/workspaces/:workspaceId/routines/:routineId/enroll', summary: 'Inscripción manual (respeta elegibilidad, horario y reglas)', tag: T,
    minRole: 'manager', params: W({ routineId: IdParam }), body: R.ManualEnrollSchema, response: R.ManualEnrollResultSchema, status: 201,
  }),
  getEnrollment: route({
    method: 'GET', path: '/workspaces/:workspaceId/enrollments/:enrollmentId', summary: 'Registro de pasos de una inscripción', tag: T,
    minRole: 'manager', params: W({ enrollmentId: IdParam }), response: R.EnrollmentDetailSchema,
  }),
  pauseEnrollment: route({
    method: 'POST', path: '/workspaces/:workspaceId/enrollments/:enrollmentId/pause', summary: 'Pausar inscripción', tag: T,
    minRole: 'manager', params: W({ enrollmentId: IdParam }), response: R.EnrollmentDetailSchema,
  }),
  resumeEnrollment: route({
    method: 'POST', path: '/workspaces/:workspaceId/enrollments/:enrollmentId/resume', summary: 'Reanudar inscripción (recalcula horarios)', tag: T,
    minRole: 'manager', params: W({ enrollmentId: IdParam }), response: R.EnrollmentDetailSchema,
  }),
  exitEnrollment: route({
    method: 'POST', path: '/workspaces/:workspaceId/enrollments/:enrollmentId/exit', summary: 'Sacar de la rutina (cancela pasos pendientes)', tag: T,
    minRole: 'manager', params: W({ enrollmentId: IdParam }), response: OkSchema,
  }),
} as const;
